export default __webpack_public_path__ + "static/media/pokemon.ce3ce165.webp";